/* global window, document, URL, Blob */

import * as R from 'ramda';

export default function CompletedPmDocumentController(
  $q,
  $scope,
  $rootScope,

  alerts,
  pmDataService,
  confirmDialog,
  loaderService,
  editDocumentAttachmentDialog,
  ssDialogService
) {
  const vm = this;

  vm.isExpanded = false;
  vm.attachmentsLoaded = false;
  vm.loaderService = loaderService;

  vm.handleAttachItems = _handleAttachItems;
  vm.handleExpandDocument = _handleExpandDocument;
  vm.handleUnapprove = _handleUnapprove;
  vm.handleDelete = _handleDelete;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;
  vm.handleDownloadAllForms = _handleDownloadAllForms;
  vm.handleDownloadAllAddenda = _handleDownloadAllAddenda;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    const dfdActivate = $q.defer();

    _initPermissions();
    _initEventListeners();
    dfdActivate.resolve();
  }

  function _initPermissions() {
    vm.canExpand = true;
  }

  function _initEventListeners() {
    $scope.$on('refreshPMDocumentAttachments', (event, opt) => {
      if (opt.policyDocumentId === vm.document.policyDocumentId) {
        _refreshAttachments();
      }
    });
  }

  function _handleExpandDocument() {
    if (!vm.attachmentsLoaded) {
      _refreshAttachments().then(() => {
        vm.isExpanded = !vm.isExpanded;
      });
    } else {
      vm.isExpanded = !vm.isExpanded;
    }
  }

  function _handleAttachItems($event) {
    ssDialogService.dialogs.pm.editDocumentAttachmentDialog = ssDialogService.alert(
      editDocumentAttachmentDialog.getOptions($event, {
        document: vm.document,
        attachment: {
          policyDocumentAttachmentId: 0,
          deletable: true,
        },
      })
    );
    ssDialogService.show(ssDialogService.dialogs.pm.editDocumentAttachmentDialog);
  }

  // Unapprove Document

  function _handleUnapprove($event) {
    ssDialogService.dialogs.pm.unapproveApprovedDocumentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Unapprove Document?',
        message: `Are you sure you want to Unapprove Document "${vm.document.name}"? This will make the Document
         active again."`,
        handleYesClick: _handleConfirmUnapprove,
        handleNoClick: _handleCancelUnapprove,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.pm.unapproveApprovedDocumentConfirmDialog);
  }

  function _handleConfirmUnapprove() {
    loaderService.showViewLoader = true;
    return pmDataService.unapproveDocument(vm.document.policyDocumentId).then(() => {
      alerts.success('The Document has been unapproved successfully.');
      $rootScope.$broadcast('refreshPMDocuments');
      _closeUnapproveDialog();
    }).catch(() => {
      alerts.error('An error occurred unapproving the Document.');
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  function _handleCancelUnapprove() {
    _closeUnapproveDialog();
  }

  function _closeUnapproveDialog() {
    ssDialogService.hide(ssDialogService.dialogs.pm.unapproveApprovedDocumentConfirmDialog);
  }

  // Delete Document

  function _handleDelete($event) {
    ssDialogService.dialogs.pm.deleteCompletedDocumentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Document?',
        message: `Are you sure you want to delete document "${vm.document.name}"?"`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.pm.deleteCompletedDocumentConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return pmDataService.deletePolicyDocument(vm.document.policyDocumentId)
      .then(() => {
        alerts.success('The document has been deleted successfully.');
        $rootScope.$broadcast('refreshPMDocuments');
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('An error occurred deleting the document.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _refreshAttachments() {
    loaderService.showViewLoader = true;
    return $q.all([
      pmDataService.getSupportingDocumentsByPolicyDocument(vm.document.policyDocumentId),
      pmDataService.getAddendaByPolicyDocument(vm.document.policyDocumentId),
    ]).then((responses) => {
      vm.attachmentsLoaded = true;
      vm.supportingDocuments = responses[0].data.result;
      vm.addenda = responses[1].data.result;
      loaderService.showViewLoader = false;
    });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.pm.deleteCompletedDocumentConfirmDialog);
  }

  function _handleDownloadAllForms() {
    loaderService.showViewLoader = true;
    pmDataService.downloadAllDocumentSupportingDocuments(vm.document.policyDocumentId).then((response) => {
      _handleDownload(response);
    });
  }

  function _handleDownloadAllAddenda() {
    loaderService.showViewLoader = true;
    pmDataService.downloadAllDocumentAddenda(vm.document.policyDocumentId).then((response) => {
      _handleDownload(response);
    });
  }

  function _handleDownload(response) {
    alerts.success('The file download will start momentarily.');
    const contentDisposition = response.headers('Content-Disposition');

    if (!R.isNil(contentDisposition)) {
      const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/g.exec(contentDisposition);
      vm.downloadName = matches && matches.length > 1 ? matches[1] : null;
      vm.downloadName = vm.downloadName.split('"').join('');
    }

    const blob = new Blob(
      [response.data],
      { type: 'application/x-zip-compressed', }
    );

    // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, vm.downloadName);
    } else {
      const anchor = document.createElement('a');
      document.body.appendChild(anchor);
      anchor.setAttribute('type', 'hidden');

      anchor.href = URL.createObjectURL(blob);
      anchor.download = vm.downloadName;
      anchor.target = '_self';
      anchor.click();
    }

    loaderService.showViewLoader = false;
  }
}

CompletedPmDocumentController.$inject = [
  '$q',
  '$scope',
  '$rootScope',

  'alerts',
  'pmDataService',
  'confirmDialog',
  'loaderService',
  'editDocumentAttachmentDialog',
  'ssDialogService'
];
